module.exports = __webpack_public_path__ + "img/Group 427323550.a9add32c.png";